// extracted by mini-css-extract-plugin
export default {"container":"NoteItem_container__nLqms","username":"NoteItem_username__Zxsl0","dateTime":"NoteItem_dateTime__Ez7yz","userInfo":"NoteItem_userInfo__m+8Gf"};